// Helpers de etiquetado de stops/paradas en toda la UI. Centralizan
// la regla "secuencia del Excel vs sin secuencia" para que todos los
// lugares (tracking, supervisor, orders, operación en vivo) muestren
// lo mismo:
//
//   - Con secuencia del Excel  → "N+1" / "Parada #N+1" / "Secuencia N+1"
//   - Sin secuencia + clientCode → "Cod XYZ" / "Cliente XYZ"
//   - Sin nada                  → "—" o "s/orden"
//
// El backend manda `sequence: number | null` en RouteStopRow; null
// significa "el Excel no traía SECUENCIA para esta fila" — la UI
// debe identificar la visita por código en ese caso.

type StopSeqInfo = {
  sequence: number | null;
  client_code?: string | null;
  client_name?: string | null;
};

/// Etiqueta numérica corta para un pin del mapa o un avatar (1-indexed).
/// Cuando no hay secuencia ni código devuelve "·".
export function stopShortLabel(s: StopSeqInfo): string {
  if (s.sequence !== null && s.sequence !== undefined) {
    return String(s.sequence + 1);
  }
  if (s.client_code) return s.client_code;
  return "·";
}

/// Título de fallback cuando el stop no trae nombre de cliente.
/// Prefiere "Parada #N+1" si hay secuencia; sino "Cod XYZ" si hay code;
/// sino "Parada s/orden" como último recurso.
export function stopFallbackTitle(s: StopSeqInfo): string {
  if (s.sequence !== null && s.sequence !== undefined) {
    return `Parada #${s.sequence + 1}`;
  }
  if (s.client_code) return `Cod ${s.client_code}`;
  return "Parada s/orden";
}

/// Nombre con fallback: cliente si lo hay, sino [stopFallbackTitle].
export function stopDisplayName(s: StopSeqInfo): string {
  if (s.client_name && s.client_name.trim() !== "") return s.client_name;
  return stopFallbackTitle(s);
}

/// "#N+1" o "—" según haya secuencia.
export function stopHash(s: StopSeqInfo): string {
  if (s.sequence !== null && s.sequence !== undefined) {
    return `#${s.sequence + 1}`;
  }
  return "—";
}
